import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { SpinnerComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-file-set-conflict-dialog',
  imports: [CommonModule, A11yModule, TranslocoModule, SpinnerComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './file-set-conflict-dialog.component.html',
  styleUrl: './file-set-conflict-dialog.component.scss',
})
export class FileSetConflictDialogComponent implements AfterViewInit {
  @Input() editable = false;
  @Input() busy = false;
  @Output() rebase = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  @ViewChild('rebaseButton', { read: ElementRef })
  private rebaseButton?: ElementRef<HTMLButtonElement>;

  @ViewChild('reloadButton', { read: ElementRef })
  private reloadButton?: ElementRef<HTMLButtonElement>;

  readonly titleId = 'file-set-conflict-title';
  readonly descriptionId = 'file-set-conflict-description';

  ngAfterViewInit(): void {
    (this.editable
      ? this.rebaseButton
      : this.reloadButton
    )?.nativeElement.focus();
  }

  onRebase(): void {
    if (!this.busy && this.editable) this.rebase.emit();
  }

  onReload(): void {
    if (!this.busy) this.reload.emit();
  }
}
